<template>
  <section class="product">
    <h2 class="title">最新动态</h2>
    <div class="bar">
      <div class="circular"></div>
    </div>
    <p class="subheading">我们的产品广泛应用于机场、地铁、港口、楼宇等领域</p>
    <div class="solution">
      <div class="solution-content">
        <div class="first">
          <div class="grid-content">
            <div class="image">
              <img class="picture" src="../../assets/img/page_1.jpg"/>
              <div class="name">电力自动化</div>
            </div>
            <div class="project">
              <h3 class="subtitle">深圳地铁</h3>
              <p class="detailed">
                公司在轨道交通行业中标的第一个项目是深圳地铁一期110KV变电站综合自动化系统工程。深圳地铁一期是深圳市第一个国家重点工
                程，也是深圳建市以来投资最大的市政重大工程。我们提供的可靠产品和优秀的服务质量，赢得了用户的信赖。
              </p>
              <!-- <a class="link">
                了解更多
                <v-icon class="more" name="arrow-right"/>
              </a> -->
            </div>
          </div>
        </div>
      </div>
      <div class="solution-content">
        <div class="second">
          <div class="grid-content">
            <div class="image">
              <img class="picture" src="../../assets/img/page_2.jpg"/>
              <div class="name">新能源</div>
            </div>
            <div class="project">
              <h3 class="subtitle">荆门生态科技城</h3>
              <p class="detailed">
                公司在轨道交通行业中标的第一个项目是深圳地铁一期110KV变电站综合自动化系统工程。深圳地铁一期是深圳市第一个国家重点工
                程，也是深圳建市以来投资最大的市政重大工程。我们提供的可靠产品和优秀的服务质量，赢得了用户的信赖。
              </p>
              <!-- <a class="link">
                了解更多
                <v-icon class="more" name="arrow-right"/>
              </a> -->
            </div>
          </div>
        </div>
      </div>
      <div class="solution-content">
        <div class="third">
          <div class="grid-content clearance">
            <div class="image">
              <img class="picture" src="../../assets/img/page_3.jpg"/>
              <div class="name">海外案例</div>
            </div>
            <div class="project">
              <h3 class="subtitle">白俄罗斯</h3>
              <p class="detailed">
                公司在轨道交通行业中标的第一个项目是深圳地铁一期110KV变电站综合自动化系统工程。深圳地铁一期是深圳市第一个国家重点工
                程，也是深圳建市以来投资最大的市政重大工程。我们提供的可靠产品和优秀的服务质量，赢得了用户的信赖。
              </p>
              <!-- <a class="link">
                了解更多
                <v-icon class="more" name="arrow-right"/>
              </a> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "product"
}
</script>

<style lang="scss" scoped>
.product {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 70px;
  padding-bottom: 40px;
  margin-right: auto;
  margin-left: auto;

  @media (max-width: 260px) {
    .grid-content {
      width: 219px;
    }
  }

  @media (max-width: 576px) {
    max-width: 540px;

    .subheading {
      padding: 0 15px;
      text-align: left;
      text-indent: 25px;
    }

    .clearance{
      margin-bottom: 0px;
    }

    .solution {
      display: inline;
    }

    padding-right: 0px;
    padding-left: 0px;
  }

  @media (min-width: 576px) {
    max-width: 540px;
  }

  @media (min-width: 768px) {
    max-width: 620px;
  }

  @media (min-width: 992px) {
    max-width: 860px;
  }

  @media (min-width: 1200px) {
    max-width: 1040px;
  }
}

.title {
  font-size: 22px;
  margin: 0;
}

.bar {
  height: 4px;
  width: 90px;
  background: #ffe1fd;
  margin: 20px auto;
  position: relative;
  border-radius: 40px;

  .circular {
    position: absolute;
    left: 0;
    top: -3.2px;
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background: #e36cd9;
    animation: mymove 4s infinite;
    -webkit-animation: mymove 4s infinite; /*Safari and Chrome both*/

    @keyframes mymove {
      from {
        left: 0px;
      }

      to {
        left: 82px;
      }
    }

    @-webkit-keyframes mymove /*Safari and Chrome*/ {
      from {
        left: 0px;
      }
      
      to {
        left: 82px;
      }
    }
  }
}

.subheading {
  font-size: 14px;
  max-width: 520px;
  margin: 0 auto;
  margin-bottom: 50px;
  color: #6084a4;
  line-height: 1.9;
}

.solution {
  display: flex;
  &:last-child {
    margin-bottom: 0;
  }
}

.solution-content {
  position: relative;
  padding: 0 15px;
  flex: 1;
}

.grid-content {
  position: relative;
  text-align: left;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  margin-bottom: 30px;

  .subtitle {
    font-size: 15px;
    transition: 0.5s;
    margin: 0px;
    line-height: 1.4;
    z-index: 999;
  }

  .detailed{
    margin-bottom: 10px;
    transition: 0.9s;
    color: #6084a4;
    line-height: 1.9;
    font-size: 13px;
    letter-spacing: 1px;
  }

  .link {
    line-height: 1.5;
    color: #455e75;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;

    .more {
      margin-left: 4px;
      width: 10px;
      height: 35px;
    }
  }
  .image {
    position: relative;

    .picture {
      display: block;
      width: 100%;
    }

    .name {
      float: left;
      position: absolute;
      left: 20px;
      bottom: -15px;
      background: linear-gradient(135deg, #f48665 0%, #fda23f 100%);
      color: #ffffff;
      padding: 8px 16px;
      font-size: 13px;
      border-radius: 50px;
    }
  }

  .project {
    background: #f7fafd;
    transition: 0.5s;
    padding-top: 32px;
    padding-left: 20px;
    padding-bottom: 16px;
    padding-right: 20px;

    .subtitle {
      margin: 0px;
      font-size: 15px;
      &:hover {
        color: #44ce6f;
      }
    }
  }

  &:hover {

    .project {
      background: #ffffff;
      box-shadow: 0 2px 48px 0 rgba(0, 0, 0, 0.08);
    }
  }
}

.icon {
  display: inline-block;
  color: #44ce6f;
  width: 85px;
  height: 85px;
  line-height: 85px;
  border: 1px solid #e3f7e9;
  border-radius: 50%;
  font-size: 24px;
}
</style>